import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import {BrowserRouter as Router, Link} from "react-router-dom";
import Helmet from "react-helmet";
import ErrorMessage from "../../components/ErrorMessage";
import {config} from "../../components/Constants";
import {Button, Col, Container, Row} from "react-bootstrap";

class Tools extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            isLoggedIn: false,
        };
    }

    componentDidMount() {
        this.setState({
            isLoaded: true
        });
    }

    render() {
        const {error, isLoaded, isLoggedIn } = this.state;
        const that = this;
        if (!isLoaded) {
            return (
                <LoadingSpin/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {
                        'title': 'Powrót', 'callback': function () {
                            that.setState({redirect: '/clients', error: null});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({redirect: '/clients', error: null});
                }}/>
            );
        } else {
            return (
                <React.Fragment>
                    <Helmet>
                        <title>Narzędzia</title>
                    </Helmet>
                    <header className="clients-header">
                        <h1>Narzędzia</h1>
                    </header>
                    <div className="section-div">
                        <Container fluid={true}>
                            <Row>
                                <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                    <Link to={'/tools/changeServicePasswd'} className="btn btn-primary">
                                        Zmień hasło dla wszystkich kont serwisowych
                                    </Link>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default Tools;
